<script setup lang="ts">
import type { ShipexkursTab } from '~~/types';
import type { GameVehicleSummary } from "~~/types/gamedata";

const props = defineProps({
  vehicle: {
    type: Object as () => GameVehicleSummary,
    required: true,
  },
});

const tabs = computed<ShipexkursTab[]>(() => [{
  label: 'Basis',
  icon: 'chip',
  items: [{
    label: 'Hersteller',
    value: props.vehicle.manufacturer.name,
  },
  {
    label: 'Modell',
    value: props.vehicle.name,
  },
  {
    label: 'Rolle',
    value: props.vehicle.role,
  },
  {
    label: 'Karriere',
    value: props.vehicle.career,
  }],
}]);
</script>

<template>
  <ShipexkursShipTable :tabs="tabs" />
</template>
